module.exports = __webpack_public_path__ + "img/icon_shcg.bfe089a9.png";